import store from '@/store'

export default function (router) {
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth === true) && !store.state.auth.user) {
      next({ name: 'login' })
    } else if (to.matched.some(record => record.meta.auth === false) && store.state.auth.user) {
      next({ name: 'home' })
    } else {
      next()
    }
  })
}
